module.exports = __webpack_public_path__ + "static/media/frog.f4ab4d9d.jpeg";